import { Injectable } from '@angular/core';
import { BrandingService } from '@citi-gcg-173875/citi-branding';
import { CookieService } from '@citi-gcg-173875/citi-utils';
import { MktContentService } from 'src/app/core/services/mkt-content.service';
import { MktDynamicOfferService } from 'src/app/core/services/mkt-dynamic-offer.service';

@Injectable({
    providedIn: 'root'
})
export class MktBrandingService {
    private csrHeader: String;
    private ssrHeader: String;
    private legacyHeader: String;
    public isSessionActive: boolean = false;
    private brandingDataObj: any;

    constructor(
        private _cookieService: CookieService,
        private brandingService: BrandingService,
        private mktDynamicOfferService: MktDynamicOfferService,
        private _mktContentService: MktContentService
    ) { }

    hideNavigationRaf() {
        this.brandingService.onDataReady.subscribe(() => {
            let data = this.brandingService.getData();
            if (!!data && !!data.footer && !!data.header) {
                data.header.navigation.show = false;
                this.brandingService.setData(data);
            }
        });
    }

    digitalPayHideFooter() {
        this.brandingService.onDataReady.subscribe(() => {
            const data = this.brandingService.getData();
            if (!!data && !!data.footer && !!data.header) {
                this.brandingService.showFooterLinks(false);
                this.brandingService.showFooterLogos(false);
                data.footer.disclaimer.show = false;
                data.footer.navigation.show = false;
                data.footer.badgeNavigation.show = false;
                data.footer.subNavigation.show = false;
                data.footer.subFooter.show = false;
                this.brandingService.setData(data);
            }
        });
    }

    showHeaderFooter() {
        try {
            this.ssrHeader = this.mktDynamicOfferService.cbolSSRUrl();
            this.csrHeader = this.mktDynamicOfferService.cbolNGAUrl();
            this.legacyHeader = this.mktDynamicOfferService.cbolUrl();
            this.brandingService.onDataReady.subscribe((dataIsReady: any) => {
                this.brandingDataObj = this._mktContentService.get('Branding', 'copy', 'Branding_1.5', undefined);
                if (dataIsReady) {
                    let data = this.brandingService.getData();
                    if (!!data && !!data.footer && !!data.header) {
                        data = this.headerSetup(data);
                        data = this.footerSetup(data);
                        this.brandingService.setData(data);
                    }
                }
            });
        } catch (err) { }
    }

    hideHeaderFooter() {
        this.brandingService.onDataReady.subscribe(() => {
            const data = this.brandingService.getData();
            if (!!data && !!data.footer && !!data.header) {
                data.header.banner.show = false;
                data.header.navigation.show = false;
                this.brandingService.showFooterLinks(false);
                this.brandingService.showFooterLogos(false);
                data.footer.disclaimer.show = false;
                data.footer.navigation.show = false;
                data.footer.badgeNavigation.show = false;
                data.footer.subNavigation.show = false;
                data.footer.subFooter.show = false;
                this.brandingService.setData(data);
            }
        });
    }

    hideHeaderOnly() {
      this.brandingService.onDataReady.subscribe(() => {
          const data = this.brandingService.getData();
          if (!!data && !!data.footer && !!data.header) {
              data.header.banner.show = false;
              data.header.navigation.show = false;
              this.brandingService.setData(data);
          }
      });
  }

    headerSetup(data) {
        try {
            const isLoggedIn = this._cookieService.getCookie('isLoggedIn');
            let bannerData = data.header.banner;
            let navigationData = data.header.navigation;
            if (isLoggedIn === "true") {
                const ecmCookie = this._cookieService.getCookie('CBOLECM');
                if (!!navigationData?.navigationItems && !!this.brandingDataObj.navHeaderPostLogin) {
                    navigationData.navigationItems = JSON.parse(this.brandingDataObj?.navHeaderPostLogin)?.navigationItems;
                }
                if (!!data.header.banner && !!data.header.butler && !!this.brandingDataObj.bannerButtonsPostLogin) {
                    data.header.banner.buttonsData = JSON.parse(this.brandingDataObj?.bannerButtonsPostLogin)?.buttonsData;
                }
                if (!!navigationData?.navigationItems) {
                    for (let navigationItemsData of navigationData.navigationItems) {
                        if (!!ecmCookie && ecmCookie.split('-')[57] === 'Y') {
                            if (navigationItemsData.title === 'Investing' || navigationItemsData.title === 'Wealth Management') {
                                navigationItemsData.show = false;
                            }
                        }
                        if (navigationItemsData.id === 'profilesNav') { }
                        else if (navigationItemsData.id === 'ATMNav') {
                            navigationItemsData.domainMap = "default";
                            navigationItemsData.url = this.csrHeader + navigationItemsData.routerLink;
                            navigationItemsData.routerLink = "";
                        }
                        else if (navigationItemsData.id === 'butlerEspanol') {
                            if (!!navigationItemsData.speedbump) {
                                navigationItemsData.speedbump.urlSuffix = "";
                                navigationItemsData.speedbump.url = this.legacyHeader + "/US/login.do?locale=es_US";
                            }
                        }
                        else if (navigationItemsData.id === 'navHelp') {
                            navigationItemsData.url = this.csrHeader + navigationItemsData.routerLink;
                            navigationItemsData.routerLink = '';
                            navigationItemsData.show = true;
                        }
                        else if (navigationItemsData.id === 'signOff') {
                            continue;
                        }
                        else {
                            if (!!navigationItemsData.navigationItems && !!navigationItemsData.navigationItems[0]?.items) {
                                for (let navigationItemsInnerData of navigationItemsData.navigationItems) {
                                    for (let navigationItemsInnerItems of navigationItemsInnerData?.items) {
                                        navigationItemsInnerItems.show = true;
                                        if (navigationItemsInnerItems.domainMap !== "default") {
                                            navigationItemsInnerItems = this.mktBrandingMapping(navigationItemsInnerItems);
                                        }
                                        else {
                                            if (navigationItemsInnerItems.url.includes('https://www.citi.com/credit-cards')) {
                                                navigationItemsInnerItems.url = navigationItemsInnerItems.url.replace('https://www.citi.com/credit-cards', '/credit-cards');
                                                if (navigationItemsInnerItems.url.includes('intc=citihpmenu~')) {
                                                    navigationItemsInnerItems.url = navigationItemsInnerItems.url.replace('intc=citihpmenu~', 'intc=megamenu~');
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            else {
                if (!!navigationData?.navigationItems) {
                    for (let navigationItemsData of navigationData.navigationItems) {
                        if (navigationItemsData.id === 'butlerEspanol') {
                            if (!!navigationItemsData.speedbump) {
                                navigationItemsData.speedbump.urlSuffix = "";
                                navigationItemsData.speedbump.url = this.legacyHeader + "/US/login.do?locale=es_US";
                            }
                        }
                    }
                }
                if (!!bannerData?.logo) {
                    bannerData.domainMap = "ssr";
                }
            }

            if (!!bannerData?.buttonsData[0]) {
                bannerData.buttonsData[0].url = this.csrHeader + bannerData.buttonsData[0].url;
                bannerData.buttonsData[0].domainMap = "default";
            }
            if (!!bannerData?.buttonsData[2]) {
                if (!!bannerData.buttonsData[2].speedbump) {
                    bannerData.buttonsData[2].speedbump.urlSuffix = "";
                    bannerData.buttonsData[2].speedbump.url = this.legacyHeader + "/US/login.do?locale=es_US";
                }
            }
            data.header.banner = bannerData;
            data.header.navigation = navigationData;
            return data;
        } catch (err) { }
    }

    footerSetup(data) {
        try {
            const locale = this._cookieService.getCookie('locale');
            let navFooterHelpSupport = JSON.parse(this.brandingDataObj.navFooterHelpSupport);
            let navFooterContactUs = JSON.parse(this.brandingDataObj?.navFooterContactUs);
            if (locale === 'es_US') {
                if (!!navFooterHelpSupport.title) {
                    navFooterHelpSupport.title = navFooterHelpSupport.title_es_US;
                    if (navFooterHelpSupport.links) {
                        for (let link of navFooterHelpSupport.links) {
                            link.title = link.title_es_US;
                        }
                    }
                }
                if (!!navFooterContactUs) {
                    navFooterContactUs.title = navFooterContactUs.title_es_US;
                    if (navFooterContactUs.links) {
                        for (let link of navFooterContactUs.links) {
                            link.title = link.title_es_US;
                        }
                    }
                }
            }
            if (!!data.footer.navigation?.sections && (data.footer.navigation?.sections[4]?.title === 'Help &amp; Support' || data.footer.navigation?.sections[4]?.title === 'Ayuda y Apoyo') && !!navFooterHelpSupport) {
                data.footer.navigation.sections[4] = navFooterHelpSupport;
            }
            if (!!data.footer.navigation?.sections && !!navFooterContactUs) {
                data.footer.navigation.sections.push(navFooterContactUs);
            }
            if (!!data.footer?.subFooter?.images) {
                data.footer.subFooter.images.fdic = false;
                data.footer.subFooter.images.equalHousing = false;
            }
            return data;

        } catch (err) { }
    }

    mktBrandingMapping(navigationItems) {
        if (navigationItems.domainMap === "csr") {
            if (!!navigationItems.routerLink) {
                if (!!navigationItems.routerLink.includes('https://online.citi.com/US/ag')) {
                    navigationItems.routerLink = navigationItems.routerLink.replace('https://online.citi.com/US/ag', '');
                }
                navigationItems.url = this.csrHeader + navigationItems.routerLink;
                navigationItems.routerLink = "";
            }
            else {
                if (!!navigationItems.url && !!navigationItems.url.includes('https://online.citi.com/US/ag')) {
                    navigationItems.url = navigationItems.url.replace('https://online.citi.com/US/ag', '');
                }
                navigationItems.url = this.csrHeader + navigationItems.url;
            }
        }
        else if (navigationItems.domainMap === "legacy" || navigationItems.domainMap === "mfe") {
            if (!!navigationItems.routerLink) {
                if (!!navigationItems.routerLink && !!navigationItems.routerLink.includes('https://online.citi.com')) {
                    navigationItems.routerLink = navigationItems.routerLink.replace('https://online.citi.com', '');
                }
                navigationItems.url = this.legacyHeader + navigationItems.routerLink;
                navigationItems.routerLink = "";
            }
            else {
                if (!!navigationItems.url && !!navigationItems.url.includes('https://online.citi.com')) {
                    navigationItems.url = navigationItems.url.replace('https://online.citi.com', '');
                }
                navigationItems.url = this.legacyHeader + navigationItems.url;
            }
        }
        else if (navigationItems.domainMap === "ssr") {
            if (!!navigationItems.routerLink) {
                if (!!navigationItems.routerLink && !!navigationItems.routerLink.includes('https://www.citi.com')) {
                    navigationItems.routerLink = navigationItems.routerLink.replace('https://www.citi.com', '');
                }
                navigationItems.url = this.ssrHeader + navigationItems.routerLink;
                navigationItems.routerLink = "";
            }
            else {
                if (!!navigationItems.url && !!navigationItems.url.includes('https://www.citi.com')) {
                    navigationItems.url = navigationItems.url.replace('https://www.citi.com', '');
                }
                navigationItems.url = this.ssrHeader + navigationItems.url;
            }
        }
        navigationItems.domainMap = "default";
        return navigationItems;
    }
}
